// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Allergies-module__button___TEVP5 {
  height: 38px;
  margin: -8px 0 8px 0;
}

.Allergies-module__checkbox___ahSbr {
  min-width: 150px;
}`, "",{"version":3,"sources":["webpack://./src/pages/PatientDetails/fragments/Allergies/Allergies.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,oBAAA;AACF;;AAEA;EACE,gBAAA;AACF","sourcesContent":[".button {\n  height: 38px;\n  margin: -8px 0 8px 0;\n}\n\n.checkbox {\n  min-width: 150px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Allergies-module__button___TEVP5`,
	"checkbox": `Allergies-module__checkbox___ahSbr`
};
module.exports = ___CSS_LOADER_EXPORT___;
